<div class="bigger-container">
  <div class="left-section">
    <p class="filter-title">Filtra</p>
    <form class="filters" [formGroup]="filters">
      <div>
        <label>ID</label>
        <input type="number" formControlName="id" placeholder="Cerca per ID" />
      </div>
      <div>
        <label>Richiedente</label>
        <input
          type="text"
          formControlName="parent"
          placeholder="Cerca per nome/cognome"
        />
      </div>
      <div>
        <label>Email</label>
        <input
          type="text"
          formControlName="email"
          placeholder="Cerca per email"
        />
      </div>
      <div>
        <label>Telefono</label>
        <input
          type="text"
          formControlName="phone"
          placeholder="Cerca per telefono"
        />
      </div>
      <div>
        <label>Categoria</label>
        <select formControlName="category">
          <option default>TUTTI</option>
          <option value="BABYSITTER">BABYSITTER</option>
          <option value="PETSITTER">PETSITTER</option>
          <option value="NURSE">BADANTI</option>
          <option value="COLF">COLF</option>
          <option value="NUTRITIONIST">NUTRIZIONISTI</option>
          <option value="PSYCHOLOGIST">PSICOLOGI</option>
          <option value="COACH">COACH</option>
          <option value="VIDEO_CONSULTATION">VIDEO CONSULTO</option>
          <option value="IN_PERSON">VISITA MEDICA DI PERSONA</option>
          <option value="LONGEVITY">LONGEVITY</option>
          <option value="CAREGIVER_CONSULT">SUPPORTO CAREGIVER</option>
        </select>
      </div>
      <div>
        <label>Città</label>
        <input
          type="text"
          formControlName="city"
          placeholder="Cerca per città"
        />
      </div>
      <div>
        <label>Zona</label>
        <input
          type="text"
          formControlName="zone"
          placeholder="Cerca per zona"
        />
      </div>
      <div>
        <label for="status">Stato</label>
        <select id="status" formControlName="status">
          <option default>TUTTI</option>
          <option value="NUOVA">NUOVA</option>
          <option value="INVIATO PREVENTIVO">INVIATO PREVENTIVO</option>
          <option value="PREVENTIVO ACCETTATO">PREVENTIVO ACCETTATO</option>
          <option value="SELEZIONE ATTIVA">SELEZIONE ATTIVA</option>
          <option value="INVIATO CV">INVIATO CV</option>
          <option value="DA PAGARE">DA PAGARE</option>
          <option value="PAGATO">PAGATO</option>
          <option value="SELEZIONE COMPLETATA">SELEZIONE COMPLETATA</option>
          <option value="STAND-BY">STAND-BY</option>
          <option value="NON RISPONDE">NON RISPONDE</option>
          <option value="DA RICHIAMARE">DA RICHIAMARE</option>
          <option value="NON PIU’ INTERESSATO">NON PIU’ INTERESSATO</option>
        </select>
      </div>
      <div>
        <label for="status">Tipo cliente</label>
        <select id="customerType" formControlName="customerType">
          <option default>TUTTI</option>
          <option value="B2C">B2C</option>
          <option value="B2B">B2B</option>
        </select>
      </div>
      <div>
        <label for="service">Seleziona Servizio</label>
        <app-fh-service-select
          [value]="filters.get('serviceID')?.value"
          (serviceSelected)="updateFHService($event)"
          [serviceID]="serviceIDfilter"
          [isRequestList]="hideErrServiceField"
        ></app-fh-service-select>
      </div>
      <div>
        <label for="operator">Presa in carico da</label>
        <app-operator-filter
          [includeAll]="true"
          [includeNone]="true"
          [operator]="filters.get('operator')?.value"
          (valueChange)="updateOperator($event)"
        ></app-operator-filter>
      </div>
      <div>
        <label for="trash">Visualizza da</label>
        <select id="trash" formControlName="trash">
          <option [value]="false">Richieste attive</option>
          <option [value]="true">Cestino</option>
        </select>
      </div>
    </form>
    <button class="reset-button" (click)="resetFilters()">RESET</button>
  </div>
  <div class="right-section">
    <div class="smaller-container">
      <p class="smaller-text">Richieste Family Happy</p>
      <div class="smaller-bar"></div>
    </div>
    <button class="my-button" (click)="openDetail('new')">NUOVA</button>
    <div style="max-height: 70vh; overflow-y: auto">
      <table>
        <th>ID</th>
        <th>Tipo</th>
        <th>Tipo cliente</th>
        <th>Operatore</th>
        <th>Richiedente</th>
        <th>Città</th>
        <th (click)="orderBy(null)" class="clickable">
          Data
          <img
            *ngIf="sortBy === null && sortDesc"
            src="../../../assets/icon/down-arrow-icon.svg"
          />
          <img
            *ngIf="sortBy === null && !sortDesc"
            src="../../../assets/icon/up-arrow-icon.svg"
          />
        </th>
        <th>Stato</th>
        <th *ngIf="trash?.value === 'true'">Ripristina</th>
        <th>Duplica</th>
        <th>Elimina</th>
        <tbody style="overflow-y: auto">
          <a
            style="display: table-row; text-decoration: unset; color: unset"
            [href]="'request-detail/' + request.id"
            target="_blank"
            *ngFor="let request of richieste"
            (click)="
              $event.stopImmediatePropagation();
              $event.preventDefault();
              openDetail(request.id)
            "
          >
            <td
              [ngStyle]="{
                cursor: trash?.value === 'true' ? 'unset' : 'pointer',
              }"
            >
              {{ request.id }}
            </td>
            <td
              [ngStyle]="{
                cursor: trash?.value === 'true' ? 'unset' : 'pointer',
              }"
            >
              {{ request.category }}
            </td>
            <td>
              @if (request.businessLine === "B2B") {
                <span class="badge rounded-pill bg-primary">{{
                  request.businessLine
                }}</span>
              } @else {
                <span class="badge rounded-pill bg-danger">{{
                  request.businessLine
                }}</span>
              }
            </td>
            <td
              [ngStyle]="{
                cursor: trash?.value === 'true' ? 'unset' : 'pointer',
              }"
            >
              {{ request.operator || "-" }}
            </td>
            <td
              [ngStyle]="{
                cursor: trash?.value === 'true' ? 'unset' : 'pointer',
              }"
            >
              {{ request.name }}
            </td>
            <td
              [ngStyle]="{
                cursor: trash?.value === 'true' ? 'unset' : 'pointer',
              }"
            >
              {{ request.city }}
            </td>
            <td
              [ngStyle]="{
                cursor: trash?.value === 'true' ? 'unset' : 'pointer',
              }"
            >
              {{ request.date | date: "dd/MM/yyyy" }}
            </td>
            <td
              [ngStyle]="{
                cursor: trash?.value === 'true' ? 'unset' : 'pointer',
              }"
            >
              <span class="status-badge" [attr.data-status]="request.status">{{
                request.status || "-"
              }}</span>
            </td>
            <td
              *ngIf="trash?.value === 'true'"
              (click)="
                $event.stopImmediatePropagation();
                $event.preventDefault();
                restoreRequest(+request.id)
              "
            >
              <span class="action-btn action-restore" title="Ripristina">
                <i
                  class="bi bi-arrow-counterclockwise"
                  style="font-size: 16px"
                ></i>
              </span>
            </td>
            <td
              (click)="
                $event.stopImmediatePropagation();
                $event.preventDefault();
                duplicateRequest(+request.id)
              "
            >
              <span class="action-btn action-duplicate" title="Duplica">
                <i class="bi bi-copy" style="font-size: 15px"></i>
              </span>
            </td>
            <td
              (click)="
                $event.stopImmediatePropagation();
                $event.preventDefault();
                deleteRequest(+request.id)
              "
            >
              <span class="action-btn action-delete" title="Elimina">
                <i class="bi bi-trash3" style="font-size: 15px"></i>
              </span>
            </td>
          </a>
          <tr *ngIf="richieste.length === 0">
            <td colspan="7">
              Non sono state trovate richieste che soddisfano i criteri di
              ricerca.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-footer">
      <div class="footer-count">
        <i class="bi bi-list-ul"></i>
        Sono presenti <b>{{ collectionSize }} richieste</b> nella lista
      </div>
      <div class="elements-limit-container">
        <label for="elements-number">Righe per pagina</label>
        <select id="elements-number" [formControl]="elementsPerPage">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
        <ngb-pagination
          *ngIf="richieste.length > 0"
          [maxSize]="5"
          [(page)]="pageView"
          [pageSize]="pageSize"
          [collectionSize]="collectionSize"
          (pageChange)="onPageChange()"
        ></ngb-pagination>
      </div>
    </div>
    <div class="export-section" *ngIf="isAdmin">
      <span class="export-label"><i class="bi bi-download"></i> Esporta</span>
      <button class="export-btn" (click)="exportRequests()">
        <i class="bi bi-file-earmark-spreadsheet"></i> Richieste
      </button>
      <button class="export-btn" (click)="exportRequestUpdates()">
        <i class="bi bi-file-earmark-text"></i> Aggiornamenti richieste
      </button>
      <button class="export-btn" (click)="exportRegistroEventi()">
        <i class="bi bi-file-earmark-bar-graph"></i> Registro eventi
      </button>
      <button class="export-btn" (click)="exportApplications()">
        <i class="bi bi-file-earmark-person"></i> Candidature
      </button>
    </div>
  </div>
</div>

<!--Alert section-->
<app-alert
  *ngIf="showAlert"
  (save)="onAlertConfimation($event)"
  [data]="{ type: undefined }"
  [title]="'Attenzione!'"
  [message]="'Vuoi davvero eliminare questa richiesta?'"
>
</app-alert>
